module.exports = __webpack_public_path__ + "icon-128-visualisation-pivot-table.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/icon-128-visualisation-pivot-table.png
// module id = 632
// module chunks = 11